<template>
  <div>
    <StoplistNavbar 
      :menu="selectedMenu" 
      :menus="menus"
      @search="v => search = v"
      @selectMenu="id => selected_menu_id = id"/>
    <BaseTabSwitcher
      noCorners
      cssWidth="100%"
      class="stoplist-tabs"
      size="lg"
      v-model="tab"
      :tabs="[
        {
          text: $t('stoplist.tab_editor'),
          value: 'editor',
        },
        {
          text: $t('stoplist.tab_stoplist'),
          value: 'stoplist',
        },
      ]"
      v-if="ready"
    >
    </BaseTabSwitcher>
    <div class="stoplist-loader" v-if="!ready">
      <img src="../assets/loader.svg" alt="">
    </div>
    <div class="stoplist-scroll" v-else>
      <div class="stoplist-categories" v-if="tab == 'editor'">
        <StoplistCategoryRow 
          v-for="(category,index) in selectedMenu.categories"
          :key="category._id+index"
          :category="category"
          :search="search"
          @toggle="toggleStoplistItem"
          :menu="selectedMenu"
          :stoplist="stoplist"/>
      </div>
      <div class="stoplist-items" v-else>
        <StoplistItem 
          :product="product"
          @remove="removeFromStoplist(product._id)"
          v-for="product in filteredStoplistedProducts"
          :key="product._id"/>
      </div>
    </div>
  </div>
</template>

<script>
import StoplistCategoryRow from "@/components/stoplist/StoplistCategoryRow.vue";
import StoplistNavbar from "@/components/stoplist/StoplistNavbar.vue";
import StoplistItem from "@/components/stoplist/StoplistItem.vue";

import StoplistAPI from '@/api/stoplist'
import QueueAPI from '@/api/queue'

export default {
  components: {
    StoplistCategoryRow,
    StoplistNavbar,
    StoplistItem,
  },
  data() {
    return {
      tab: "editor",
      ready: false,

      menus: [],
      stoplist: [],

      search: null,

      selected_menu_id: null
    };
  },
  methods: {
    fetchMenus() {
      QueueAPI.getMenus().then(data => {
        this.menus = data.menus;
        this.ready = true;
        this.selected_menu_id = data.menus[0]._id;

        this.fetchStoplist();
      }).catch(err => {
        this.$store.commit("setError", err);
      });
    },
    fetchStoplist() {
      StoplistAPI.getStoplist(
        this.selected_menu_id
      ).then(data => {
        this.stoplist = data.stoplist;
      }).catch(err => {
         this.$store.commit("setError", err);
      }); 
    },
    addToStoplist(product_id) {
      StoplistAPI.addToStoplist(
        this.selected_menu_id,
        product_id
      ).then(data => {
        this.stoplist.push(data.item);
      }).catch(err => {
        this.$store.commit("setError", err);
      });
    },
    removeFromStoplist(product_id) {
      StoplistAPI.removeFromStoplist(
        this.selected_menu_id,
        product_id
      ).then(data => {
        this.stoplist = this.stoplist.filter(sli => {
          return sli.product_id != product_id;
        });

        this.fetchStoplist();
      }).catch(err => {
        this.$store.commit("setError", err);
      });
    },
    toggleStoplistItem(id, enable) {
      if (enable) {
        this.addToStoplist(id);
      } else {
        this.removeFromStoplist(id);
      }
    }
  },
  computed: {
    selectedMenu() {
      return this.menus.find(m => m._id == this.selected_menu_id);
    },
    stoplistedProducts() {
      return this.selectedMenu.products.filter(product => {
        return this.stoplist.find(stoplist_item => {
          return stoplist_item.product_id === product._id && stoplist_item.menu_id == this.selected_menu_id;
        });
      });
    },
    filteredStoplistedProducts() {
      let localProducts = this.stoplistedProducts;

      if (!this.search) return localProducts;

      return localProducts.filter(pr => {
        return pr.name.toLowerCase().includes(
          this.search.toLowerCase()
        );
      });
    }
  },
  mounted() {
    this.$store
      .dispatch("init")
      .then(() => {
        this.fetchMenus();
      })
      .catch((err) => {
        const saved_qid = window.localStorage.getItem(`last_qid`);
        const suffix = saved_qid ? "/" + saved_qid : "";
        this.$router.push("/login" + suffix);
      });

    window.document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    window.document.body.style.overflow = 'auto';
  }
};
</script>

<style scoped>
.stoplist-scroll {
  overflow: auto;
  max-height: calc(100vh - 56px - 40px);

  padding-bottom: 64px;
}

.stoplist-loader {
  text-align: center;
  margin-top: 16px;
}
</style>